import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { LinkContainer } from 'react-router-bootstrap';
import { MenuItem, DropdownButton } from 'react-bootstrap';

@injectIntl
@inject('membersStore', 'rootStore')
@observer
export default class SettingButton extends React.Component {
  render() {
    let { membersStore } = this.props;
    let options = membersStore.features[this.props.options];
    let id = this.props.member.id;
    let role = this.props.member.role;
    let boards = membersStore.getBoard(id);

    if (boards.includes('director')) boards.push('board_of_director');

    let { confirm } = membersStore;

    if (this.props.options === 'mRoles') {
      options = options.filter(e => e != 'ceo');
    }

   // console.log(options);

    return (
      <DropdownButton
        dropup
        pullRight
        bsStyle="default"
        title={
          <span>
            <i className="fa fa-cog fa-fw" />
          </span>
        }
        noCaret
        id="dropdown-no-caret"
      >
        {options.map((o, idx) => (
          <MenuItem
            key={idx}
            onClick={e => {
              if (confirm()) this.props.handle(id, o);
            }}
          >
            <span>
              {this.props.options === 'bRoles' && boards.includes(o) && (
                <i className="fa fa-check" />
              )}
              &nbsp;
              {this.props.intl.formatMessage({ id: o })}
            </span>
          </MenuItem>
        ))}
      </DropdownButton>
    );
  }
}
